module.exports = __webpack_public_path__ + "static/ANN-58a6c07c761817dcc1ce8616988be6c1.png";